module.exports = __webpack_public_path__ + "static/img_wj.c8c1e056.png";